// The data/schema buster remains unchanged so upgrades can migrate the existing offline cache.
export const QUERY_CACHE_BUSTER = "persisted-static-queries-v1";
export const QUERY_CACHE_MAX_AGE = 24 * 60 * 60 * 1000;

export const LEGACY_QUERY_CACHE_KEY = "REACT_QUERY_OFFLINE_CACHE";
export const MUTATION_CACHE_KEY = "HANIVERSE_QUERY_MUTATIONS_V1";
export const STATIC_QUERY_CACHE_PREFIX = "HANIVERSE_STATIC_QUERY_V1";
export const STATIC_QUERY_CACHE_METADATA_KEY = "HANIVERSE_STATIC_QUERY_METADATA_V1";
